export interface IQuestionOption {
  idQuestionOption: string;
  idQuestion: string;
  text: string;
  order: number;
}

export class QuestionOption {
  idQuestionOption: string;
  idQuestion: string;
  text: string;
  order: number;

  constructor(data: IQuestionOption) {
    this.idQuestionOption = data.idQuestionOption;
    this.idQuestion = data.idQuestion;
    this.text = data.text;
    this.order = data.order;
  }
}
